module.exports = __webpack_public_path__ + "img/choose-up-vacanta-disabled.aee7a259.png";